// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   serverUrl: 'https://us-central1-lims-gcp-01.cloudfunctions.net',
//   firebase: {
//     apiKey: "AIzaSyCy1B2SUE5wD-zJ-LP4RQNp3UxFEPZ2EJc",
//     authDomain: "lims-gcp-01.firebaseapp.com",
//     projectId: "lims-gcp-01",
//     storageBucket: "lims-gcp-01.appspot.com",
//    // storageBucket: "lims-gcp-01.appspot.com/test",
//     //storageBucket:"lims-data-usc1-organization",
//     messagingSenderId: "346825231934",
//     appId: "1:346825231934:web:439110ccd6888502de4b6f"
//   }
// };
//fileUrl: 'https://storage.cloud.google.com/labinfo-dev.appspot.com/',

// export const environment = {
//   production: false,
//   serverUrl: 'https://us-central1-labinfo-dev.cloudfunctions.net',
//   fileUrl: 'https://storage.googleapis.com/labinfo-dev.appspot.com/',
//   firebase:  {
//     apiKey: "AIzaSyBzBIvxMPOn1lZtOnmkEeMF1VHkHkrTrIE",
//     authDomain: "labinfo-dev.firebaseapp.com",
//     projectId: "labinfo-dev",
//     storageBucket: "labinfo-dev.appspot.com",
//     messagingSenderId: "124807523693",
//     appId: "1:124807523693:web:6863cc73ea6c801fdcbe64"
//   }
// };

export const environment = {
  production: true,
  serverUrl: 'https://us-central1-lims-prod.cloudfunctions.net',
  fileUrl: 'https://storage.googleapis.com/lims-prod.appspot.com/',
  firebase:  {
    apiKey: "AIzaSyDG2MK_8NZZRBBUsRCGoV22AHCBNKSUuPg",
  authDomain: "lims-prod.firebaseapp.com",
  projectId: "lims-prod",
  storageBucket: "lims-prod.appspot.com",
  messagingSenderId: "240466707054",
  appId: "1:240466707054:web:7d8c65fe2683a4ebaf9c7f"
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
